const baseUrl = '/properties';
export const propertyRoutes = {
  baseUrl: "".concat(baseUrl),
  defaultChargeOnDate: propertyId => "".concat(baseUrl, "/default-charge-on-date/").concat(propertyId)
};